/**
 * @generated SignedSource<<9b89f8bf676a1981f8caf546a79de02c>>
 * @relayHash eef5f6db0be0fcf256d96f17b8e8954c
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID eef5f6db0be0fcf256d96f17b8e8954c

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Data",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Center",
        "kind": "LinkedField",
        "name": "managementCenters",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountUpdateQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountUpdateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "eef5f6db0be0fcf256d96f17b8e8954c",
    "metadata": {},
    "name": "AccountUpdateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "ec0a49cc646343e9aac2dbe32af9a245";

export default node;
